import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log error details for debugging
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    render() {
        if (this.state.hasError) {
            // Check if we're in development mode
            const isDevelopment = import.meta.env.NODE_ENV === 'development';

            return (
                <div style={{
                    padding: '2em',
                    maxWidth: '1200px',
                    margin: '0 auto',
                    fontFamily: 'monospace'
                }}>
                    <h2 style={{ color: '#d32f2f' }}>Something went wrong</h2>
                    <p style={{ marginBottom: '1em' }}>
                        An error occurred in the application. {isDevelopment ? 'See details below.' : 'Please refresh the page or contact support.'}
                    </p>
                    
                    {isDevelopment && this.state.error && (
                        <div style={{
                            backgroundColor: '#1e1e1e',
                            color: '#d4d4d4',
                            padding: '1.5em',
                            borderRadius: '4px',
                            marginTop: '1em',
                            overflow: 'auto',
                            maxHeight: '600px'
                        }}>
                            <h3 style={{ color: '#f48771', marginTop: 0 }}>Error Message:</h3>
                            <pre style={{ 
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                margin: '0.5em 0'
                            }}>
                                {this.state.error.toString()}
                            </pre>
                            
                            {this.state.error.stack && (
                                <>
                                    <h3 style={{ color: '#f48771', marginTop: '1.5em' }}>Stack Trace:</h3>
                                    <pre style={{ 
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-word',
                                        margin: '0.5em 0',
                                        fontSize: '0.9em'
                                    }}>
                                        {this.state.error.stack}
                                    </pre>
                                </>
                            )}
                            
                            {this.state.errorInfo && this.state.errorInfo.componentStack && (
                                <>
                                    <h3 style={{ color: '#f48771', marginTop: '1.5em' }}>Component Stack:</h3>
                                    <pre style={{ 
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-word',
                                        margin: '0.5em 0',
                                        fontSize: '0.9em'
                                    }}>
                                        {this.state.errorInfo.componentStack}
                                    </pre>
                                </>
                            )}
                        </div>
                    )}
                    
                    <button 
                        onClick={() => window.location.reload()}
                        style={{
                            marginTop: '1.5em',
                            padding: '0.5em 1em',
                            fontSize: '1em',
                            cursor: 'pointer',
                            backgroundColor: '#1976d2',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px'
                        }}
                    >
                        Reload Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;

